import { useAudioControls } from "../hooks/use-audio-controls";

const SpeedButton: React.FC = () => {
  const { playbackRate, cyclePlaybackRate } = useAudioControls();

  return (
    <button
      onClick={cyclePlaybackRate}
      className="px-3 py-1.5 rounded-full flex items-center gap-1 bg-default-700 h-6 text-xs text-background"
      title="Change playback speed"
    >
      {playbackRate} <span className="text-base">×</span>
    </button>
  );
};

export default SpeedButton;
